import React, { useCallback, useMemo } from "react";
import { Tooltip } from "antd";
import { copyToClipBoard, DEFAULT_ID, getGuidFirst8 } from "@/utils/utils";
const CopyableGUID = ({ tooltipTitle, useFullGUID, guid, itemStyle }) => {
    const copyableString = useMemo(() => (useFullGUID ? guid : getGuidFirst8(guid)), [guid, useFullGUID]);
    const style = useMemo(() => ({
        cursor: "pointer",
        ...itemStyle,
    }), [itemStyle]);
    const onClick = useCallback(event => {
        // Handle case where this is placed in a table component that normally navs to a details view on row click
        event.stopPropagation();
        copyToClipBoard(copyableString);
    }, [copyableString]);
    const displayedTooltipTitle = useMemo(() => {
        if (typeof tooltipTitle === "string")
            return tooltipTitle;
        return `Copy to clipboard: ${copyableString}`;
    }, [tooltipTitle, copyableString]);
    return (React.createElement(Tooltip, { color: "#fff", title: displayedTooltipTitle },
        React.createElement("span", { onClick: onClick, style: style }, copyableString)));
};
CopyableGUID.defaultProps = {
    tooltipTitle: undefined,
    useFullGUID: false,
    guid: DEFAULT_ID,
    itemStyle: {},
};
export default CopyableGUID;
